import C from "../../common/constantes"
import Sales from '../../../services/sales'
import messageDialog from '../../../components/message-dialog.vue';
import {EventBus} from '../../../event-bus'

export default {
  props: ['type'],
  data() {
    return {
      loading: undefined,
    }
  },


  computed:{
    // sameTax(){
    //   
    //   
    //   if(this.newAhesionTaxCont == this.newVehicleTaxCont && this.newAhesionTaxConf == this.newVehicleTaxConf)
    //     return true;

    //   return false;
    // },
    getNewAdhesionTax(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_PRE_AUT_MEN_SODRE_PF);
    },
    getReplaceTax(){
      return this.$store.getters.getReplaceTax(C.PLAN_PRE_AUT_MEN_SODRE_PF);
    },
    getNewVehicleTax(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_PRE_AUT_MEN_SODRE_PF);
    },
     getMonthlyTax(){
      return this.$store.getters.getMonthlyTax(C.PLAN_PRE_AUT_MEN_SODRE_PF);
    },
},

  methods:{
    choose(planId){
      if(this.type=='newContract'){
        EventBus.$emit('chooseNewPlan', planId);
      } else {
        this.$router.push({'name': 'adhesion', 'query':{'planId': planId}});
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/pages/external/plans/b2c-sodre.js